import { render } from "./default-adenoid.vue?vue&type=template&id=67435242&scoped=true"
import script from "./default-adenoid.vue?vue&type=script&lang=js"
export * from "./default-adenoid.vue?vue&type=script&lang=js"

import "./default-adenoid.vue?vue&type=style&index=0&id=67435242&scoped=true&lang=less"

import exportComponent from "/home/runner/work/easticloud-admin/easticloud-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67435242"]])

export default __exports__